export enum TransactionType {
  All = 0,
  SpecificAdvice = 1,
  GeneralRates = 2,
}
